// What Pro includes, shown on the account page and in the upgrade pop-up

import styles from './AccountSettings.module.css'

export const FEATURES = [
  ['Unlimited recipes', 'Add every family recipe, with photos and steps.'],
  ['Unlimited family groups', 'Share with each side of the family, or a supper club.'],
  ['Audio memories', 'Keep the stories behind a dish, in their own voice.'],
  [
    'Scan a recipe card or save a link',
    'Turn handwritten cards and websites into recipes in seconds.',
  ],
  ['Printed cookbooks', 'Turn your recipes into a real, bound book.'],
]
export const FAMILY_EXTRA = [
  'Shared with your family',
  'Everyone on your plan gets Pro too, at no extra cost.',
]

const Tick = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true" style={{ flex: '0 0 auto' }}>
    <circle cx="11" cy="11" r="11" fill="#2f7d62" />
    <path d="M6 11.5l3.2 3.2L16 8" stroke="#fff" strokeWidth="2.2" fill="none" />
  </svg>
)

export const Perks = ({ items, light }) => (
  <ul className={styles.perks}>
    {items.map(([title, detail]) => (
      <li key={title} className={styles.perk}>
        <Tick />
        <span>
          <b>{title}</b>
          <small style={light ? { color: '#f7f5ad' } : undefined}>{detail}</small>
        </span>
      </li>
    ))}
  </ul>
)
